import { render, staticRenderFns } from "./InvoiceXlsx.vue?vue&type=template&id=54085bb8&"
import script from "./InvoiceXlsx.vue?vue&type=script&lang=js&"
export * from "./InvoiceXlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports